import {Tip} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

/**
 * The "adding documents helps auto-fill the form" callout shown above a document upload zone.
 * Owns its own copy so every upload surface says the same thing — callers pass nothing.
 */
export const DocumentsAutoFillTip: FC = () => {
  const {t} = useTranslation('common');

  return (
    <Tip
      title={t('documents.autoFillTip.title')}
      description={t('documents.autoFillTip.description')}
    />
  );
};
